import FailurePage from './FailurePage';

export default FailurePage;



// WEBPACK FOOTER //
// ./src/components/FailurePage/index.js